var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-container"},[_c('router-link',{attrs:{"target":"_blank","to":"/home"}},[_c('el-button',[_vm._v("看板1点我演示")])],1),_c('router-link',{attrs:{"target":"_blank","to":"/map"}},[_c('el-button',[_vm._v("看板2点我演示")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }